export default function RouteErrorPage() {
  return (
    <>
      <h1>Route Error</h1>
    </>
  );
}
